import React, { useState } from "react";
import "./App.css";
import { HeaderComponent } from "./components";
import { HomePage, ResultPage, SearchPage } from "./pages";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  const [sidebar, setSidebar] = useState({
    side: false,
  });

  const toggle = () => {
    setSidebar((prevValue) => {
      return { ...prevValue, side: !prevValue.side };
    });
  };

  return (
    <div className="app">
      <Router>
        <HeaderComponent onClick={toggle} />

        <Switch>
          <Route path="/search/:id">
            <ResultPage show={sidebar.side} />
          </Route>
          <Route path="/:id">
            <SearchPage />
          </Route>
          <Route path="/">
            <HomePage show={sidebar.side} />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
